module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<h5>' +
__e( data.name ) +
'</h5>\n<div class="include-qualifiers">\n    <div class="filter-label">' +
((__t = ( strings.include )) == null ? '' : __t) +
':</div>\n    <div class="q-content">\n        ';
 if (data.include.length) { ;
__p += '\n        ';
 data.include.forEach(function(group) { ;
__p += '\n            ' +
((__t = ( group[0] )) == null ? '' : __t) +
': ' +
((__t = ( group[1].join(", ") )) == null ? '' : __t) +
';\n        ';
 }) ;
__p += '\n        ';
 } else { ;
__p += '\n            ' +
((__t = ( strings.none )) == null ? '' : __t) +
'\n        ';
 } ;
__p += '\n    </div>\n</div>\n<div class="exclude-qualifiers">\n    <div class="filter-label">' +
((__t = ( strings.exclude )) == null ? '' : __t) +
':</div>\n    <div class="q-content">\n        ';
 if (data.exclude.length) { ;
__p += '\n            ';
 data.exclude.forEach(function(group) { ;
__p += '\n                ' +
((__t = ( group[0] )) == null ? '' : __t) +
': ' +
((__t = ( group[1].join(", ") )) == null ? '' : __t) +
';\n            ';
 }) ;
__p += '\n        ';
 } else { ;
__p += '\n            ' +
((__t = ( strings.none )) == null ? '' : __t) +
'\n        ';
 } ;
__p += '\n    </div>\n</div>\n<i data-action="delete:' +
((__t = ( data._id )) == null ? '' : __t) +
'" class="far fa-times-circle delete-filter" data-toggle="tooltip" data-placement="top" title="' +
((__t = ( strings.deleteFilter )) == null ? '' : __t) +
'"></i>';
return __p
}